import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface PurchaseInvoiceLinkProps {
  purchaseInvoiceId?: string;
}

export const PurchaseInvoiceLink: React.FC<
  PurchaseInvoiceLinkProps
> = props => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('fvzLng');

  const handleClick = () => {
    if (props.purchaseInvoiceId) {
      nav.purchaseInvoiceEditor(props.purchaseInvoiceId, true);
    }
  };

  return (
    <OverlayTrigger overlay={<Tooltip>{t(tk.common.openNewCard)}</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          handleClick();
        }}
        variant="btn-info"
        className="px-2"
      >
        <Icon.FileText className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
